import { Container, ContainerHeader, ContainerContent } from 'components/Containers/Containers'
import { Button, Flex, ThinSeparator } from 'styling/GlobalStyles'
import { BodyText, TitleText } from 'styling/Typography'
import { IOperationPlanState } from 'types/operationPlans.interface'
import { formatDateForDisplay } from 'utils/helpers'

export const Review = ({ state, handleSave, setStep }: { state: IOperationPlanState, handleSave: () => void, setStep: (step: number) => void }) => {

    const handleBack = () => setStep(5)

    return <>
        <Flex column gap='1rem' >
            <Container>
                <ContainerHeader>
                    <TitleText>IDENTITY</TitleText>
                </ContainerHeader>
                <ContainerContent>
                    <Flex column gap='1rem'>
                        <Flex gap='5rem' >
                            <BodyText grey >NAME</BodyText>
                            <BodyText  >{state.name} </BodyText>
                        </Flex>
                        <Flex gap='5rem' >
                            <BodyText grey >CODE</BodyText>
                            <BodyText  >{state.code || '-'} </BodyText>
                        </Flex>
                    </Flex>
                </ContainerContent>
            </Container>
            <Container>
                <ContainerHeader>
                    <TitleText>SCOPE</TitleText>
                </ContainerHeader>
                <ContainerContent>
                    <Flex column gap='1rem'>
                        <Flex gap='5rem' >
                            <BodyText grey >Site</BodyText>
                            <BodyText  >{state.site?.label || '-'} </BodyText>
                        </Flex>
                        <Flex gap='5rem' >
                            <BodyText grey >DEPARTMENT</BodyText>
                            <BodyText  >{state.department?.label || '-'} </BodyText>
                        </Flex>
                        <Flex gap='5rem' >
                            <BodyText grey >OWNER</BodyText>
                            <BodyText  >{state.owner?.label || '-'} </BodyText>
                        </Flex>
                        <Flex gap='5rem' >
                            <BodyText grey >ZONE SCOPE</BodyText>
                            <BodyText  >{state.zoneScopeLevel?.label || '-'} </BodyText>
                        </Flex>
                    </Flex>
                </ContainerContent>
            </Container>
            <Container>
                <ContainerHeader>
                    <TitleText>TARGETS</TitleText>
                </ContainerHeader>
                <ContainerContent>
                    <Flex column gap='1rem'>
                        <Flex gap='5rem' >
                            <BodyText grey >PRIORITY</BodyText>
                            <BodyText  >{state.priority?.label || '-'} </BodyText>
                        </Flex>
                        <Flex gap='5rem' >
                            <BodyText grey >TARGET</BodyText>
                            <BodyText  >{state.targetValue || '-'} {state.targetUnit?.label || '-'} </BodyText>
                        </Flex>
                        <Flex gap='5rem' >
                            <BodyText grey >BUDGET</BodyText>
                            <BodyText  >{state.targetBudgetCost || '-'} {state.targetCurrencyCode?.label || '-'} </BodyText>
                        </Flex>
                        <Flex gap='5rem' >
                            <BodyText grey >DUE DATE</BodyText>
                            <BodyText  >{state.dueAt ? formatDateForDisplay(state.dueAt) : '-'} </BodyText>
                        </Flex>
                        <Flex gap='5rem' >
                            <BodyText grey >BOARD VISIBILITY</BodyText>
                            <BodyText  >{state.boardVisibility?.label || '-'} </BodyText>
                        </Flex>
                        <Flex gap='5rem' >
                            <BodyText grey >AUTO-PAUSE ON L3</BodyText>
                            <BodyText  >{state.autoPauseOnL3Plus ? 'Yes' : 'No'} </BodyText>
                        </Flex>
                        <Flex gap='5rem' >
                            <BodyText grey >OBJECTIVE</BodyText>
                            <BodyText  >{state.objective || '-'} </BodyText>
                        </Flex>
                    </Flex>
                </ContainerContent>
            </Container>
            <Container>
                <ContainerHeader>
                    <TitleText>PHASES</TitleText>
                </ContainerHeader>
                {state.phases.length ? state.phases.map((p, k) => <ContainerContent key={p.id}>
                    <Flex column gap='1rem'>
                        <Flex gap='5rem' >
                            <BodyText grey >NAME</BodyText>
                            <BodyText  >{p.name || '-'} </BodyText>
                        </Flex>
                        <Flex gap='5rem' >
                            <BodyText grey >SEQUENCE</BodyText>
                            <BodyText  >{p.sequence || '-'} </BodyText>
                        </Flex>
                        <Flex gap='5rem' >
                            <BodyText grey >EXECUTABLE TYPE</BodyText>
                            <BodyText  >{p.executableType?.label || '-'} </BodyText>
                        </Flex>
                        <Flex gap='5rem' >
                            <BodyText grey >ADVANCE RULE</BodyText>
                            <BodyText  >{p.advanceRule?.label || '-'} </BodyText>
                        </Flex>
                        <Flex gap='5rem' >
                            <BodyText grey >WORKFLOW TEMPLATE</BodyText>
                            <BodyText  >{p.workflowTemplate?.label || '-'} </BodyText>
                        </Flex>
                        <Flex gap='5rem' >
                            <BodyText grey >PROCESS TEMPLATE</BodyText>
                            <BodyText  >{p.processTemplate?.label || '-'} </BodyText>
                        </Flex>
                        <Flex gap='5rem' >
                            <BodyText grey >TASK CYCLE TEMPLATE</BodyText>
                            <BodyText  >{p.taskCycleTemplate?.label || '-'} </BodyText>
                        </Flex>
                        {k < state.phases.length - 1 && <ThinSeparator />}
                    </Flex>
                </ContainerContent>) : <Flex mt='16' mb='16' column gap='1rem'>
                    <BodyText grey style={{ textAlign: 'center' }} >No phases added</BodyText>
                </Flex>}
            </Container>

            <Container>
                <ContainerHeader>
                    <TitleText>HORIZON</TitleText>
                </ContainerHeader>
                <ContainerContent >
                    <Flex column gap='1rem'>
                        <Flex gap='5rem' >
                            <BodyText grey >TYPE</BodyText>
                            <BodyText  >{state.horizon.horizonType?.label || '-'} </BodyText>
                        </Flex>
                        <Flex gap='5rem' >
                            <BodyText grey >SCHEDULER RUN FREQ MIN</BodyText>
                            <BodyText  >{state.horizon.schedulerRunFreqMin || '-'} </BodyText>
                        </Flex>
                        <Flex gap='5rem' >
                            <BodyText grey >REPLISH THRESHOLD</BodyText>
                            <BodyText  >{state.horizon.replenishThreshold || '-'} </BodyText>
                        </Flex>
                        <Flex gap='5rem' >
                            <BodyText grey >MAX QUEUE SIZE</BodyText>
                            <BodyText  >{state.horizon.maxQueueSize || '-'} </BodyText>
                        </Flex>
                    </Flex>
                </ContainerContent>
            </Container>

        </Flex>
        <Flex gap='1rem' mt='16' alignEnd justend>
            <Button onClick={handleBack}>Back</Button>
            <Button orange onClick={handleSave} >Save</Button>
        </Flex>
    </>
}